import { ColorHex, ServingStatus } from '@/ts/common-types';
import { getBadgeParams } from '@/ts/utils';
import React from 'react';

interface ITypeBadgeCellRenderer {
    params: any
}

const TypeBadgeCellRenderer: React.FC<ITypeBadgeCellRenderer> = ({ params }) => {
    const servingStatus =
        params.data[
            ServingStatus[params.colDef.field as keyof typeof ServingStatus]
        ]?.toLowerCase();

    const campaignType = params.isTypeBadgeRequired
        ? params.data.targetingtype
        : "";
    return (
        <div
            className="badge"
            style={{
                width: "fit-content",
                background: getBadgeParams(
                    "color",
                    "campaignType",
                    servingStatus,
                    campaignType
                ),
                color: ColorHex.WHITE
            }}
        >
            {getBadgeParams(
                "text",
                "campaignType",
                servingStatus,
                campaignType
            )}
        </div>
    )
}

export default TypeBadgeCellRenderer;